import preferences from "@coworker/enums/profilePreferences";
import { useUserPreference } from "../../hooks/useProfilePreferencesQuery";

/**
 * @deprecated use `useUserPreference(preferences.LANGUAGE)` instead
 */
export function useLanguage(): string {
  const [userLanguage] = useUserPreference(preferences.LANGUAGE, "");
  return userLanguage;
}
